<wiz-h-divider width="100%" height="100%" gap="0">
  <!-- panneau gauche -->
  <wiz-vgroup width="344px" height="100%" #vgGrid>
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove class="image-purple" [wizTooltip]="'$.common.delete.$'"
          (click)="doAct('delete')">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup target="title">
        <wiz-hgroup verticalAlign="center" gap="10">
          <wiz-icon #btnCreate [wizTooltip]="'$.profile.add.$'" tooltipPlacement="right" class="image-back-orange"
            (click)="doAct('create')">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.profile.add.$'" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        </wiz-hgroup>
      </wiz-hgroup>
    </multi-display>
  </wiz-vgroup>
  <!-- zone détail -->
  <wiz-group width="100%" height="100%">
    <!-- lorsque rien n'est sélectionné -->
    <wiz-vgroup width="100%" *ngIf="!showDetail" class="section-container-parent">
      <widget-renderer class="view-widget" width="100%" [title]="'$.profile.home.title.$'"
        [description]="'$.profile.home.description.$'"></widget-renderer>
    </wiz-vgroup>

    <wiz-vgroup #vgDetailZone [visible]="showDetail" width="100%" height="100%" class="section-container-parent"
      gap="10">
      <wiz-hgroup padding="10px" width="100%" class="section-container">
        <wiz-vgroup wizValidationContainer verticalAlign="center" width="440px">
          <!-- champ de saisi -->
          <wiz-hgroup gap="20" wizValidationContainer>
            <wiz-text-input #tiCode class="upper-case-input" width="205px" [wizLabel]="'$.common.code.$'"
              [wizValidator]="uniqueCodeValidator()" [wizShowErrors]="true" [wizMandatory]="true" [wizMaxChars]="10"
              [wizPlaceholder]="'$.common.define.$'">
            </wiz-text-input>

            <wiz-translation #tiLabelTrs wizValidator width="205px" [wizLabel]="'$.common.label.$'"
              [wizMandatory]="true" [wizPlaceholder]="'$.common.define.$'" [wizMaxChars]="100" [wizShowErrors]="true">
            </wiz-translation>
          </wiz-hgroup>
          <wiz-checkbox #chbDeprecated [wizLabel]="'$.common.deprecated.$'"></wiz-checkbox>
        </wiz-vgroup>

        <wiz-text-area #taUserFilters
          [wizLabel]="'$.common.keys.$'"
          [wizMaxChars]="1000"
          width="250px"
          height="100%">
        </wiz-text-area>

        <wiz-spacer width="100%"></wiz-spacer>

        <!-- bouton d'action -->
        <wiz-vgroup gap="0" padding="3px" width="200px">
          <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
            [iconPlacement]="'right'"></wiz-button>
          <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'"></wiz-button>
        </wiz-vgroup>
        


      </wiz-hgroup>

      <wiz-hgroup width="100%" height="100%" class="section-container" padding="10px" gap="0">
        <wiz-vgroup height="100%" minWidth="600px" width="100%" maxWidth="850px">
          <wiz-label [wizLabel]="'$.user.role.available.$'" class="smallTitleLabel"></wiz-label>
          <!-- liste des roles disponibles -->
          <wiz-ag-grid id="lsAvailableRoles" width="100%" height="100%" class="ag-theme-alpine"
            [wizDatasource]="rolesByFeature" [columnDefs]="availableRolesColumns"
            [frameworkComponents]="availableRolesRenderer" [tooltipShowDelay]="0"
            (cellClicked)="onPermissionCellClicked($event)">
          </wiz-ag-grid>
          <filter-component #availableRolesFilter> </filter-component>
        </wiz-vgroup>
      </wiz-hgroup>
    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>